import Icon, { IconProps } from './Icon';

import ClockFastForwardIcon from '../../../assets/icons/clock-fast-forward.svg?react';

const ClockFastForward: React.FC<Omit<IconProps, 'children'>> = (props) => {
    return (
        <Icon {...props}>
            <ClockFastForwardIcon />
        </Icon>
    );
};

export default ClockFastForward;
